import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DocumentService } from 'com.trumbull.phx.document.api-client';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class DocumentDeleteService {

  // private readonly documentDeleteUrl = '/api/document/v1/standard/content/internal.repo.1'

  constructor(private readonly http: HttpClient, private readonly documentService: DocumentService) {}

  // deleteDocument(payload: string): Observable<any> {
  //   const url = `${this.documentDeleteUrl}/${payload}`;
  //   return this.http.delete<any>(url);    
  // }

  /*
  * Document Upload Service 
  */
 
  deleteDocument( providerId: string, payload: string, storageProviderId = 'internal.repo.1'): Observable<any> {
    return this.documentService.deleteDocumentContent(providerId, payload, storageProviderId);
   }
 
}
